import { render, staticRenderFns } from "./TypeMessageHTML.vue?vue&type=template&id=0bb9b4aa&scoped=true"
import script from "./TypeMessageHTML.vue?vue&type=script&lang=js"
export * from "./TypeMessageHTML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9b4aa",
  null
  
)

export default component.exports